export default "__VITE_ASSET__DWMtE4ik__"